export default __webpack_public_path__ + "static/image1-31aa2b7df30ea601c56d30dcce9e1108.jpeg";